
import { defineComponent, PropType, computed, toRefs } from 'vue';
import { RouterLink } from 'vue-router';
import { ElButton } from 'element-plus';
import { StyleTag } from '@/components/common';
import { AlbumModel } from '@/typings';

export default defineComponent({
    components: {
        ElButton,
        RouterLink,
        StyleTag
    },
    props: {
        buttonText: {
            type: String,
            default: '选择'
        },
        index: {
            type: Number,
            default: 0
        },
        album: {
            type: Object as PropType<AlbumModel>,
            required: true
        }
    },
    emits: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        handleSelect (val:number) {
            return true;
        }
    },
    setup (props, { emit }) {
        const {
            album,
            index
        } = toRefs(props);

        const stylesInShow = computed(() => {
            if (!album.value.styles) {
                return [];
            }
            return album.value.styles.slice(0, 4);
        });

        const handleSelect = () => {
            emit('handleSelect', index.value);
        };

        return {
            stylesInShow,
            handleSelect
        };
    }
});
